// extracted by mini-css-extract-plugin
module.exports = {"Unauthorised":"Unauthorised__iJevt","UnauthorisedMessage":"UnauthorisedMessage__2eVsb"};